import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';

function EventDescComp({
  mainBody,
  layoutImgCont,
  eventLayoutUrl,
  layoutImg,
  bodyCont,
  head,
  actualBody,
  eventDescription,
}) {
  return (
    <div className={mainBody}>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <div className={layoutImgCont}>
            <CardMedia
              component="img"
              alt="layout"
              image={eventLayoutUrl}
              title="layout"
              className={layoutImg}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={bodyCont}>
            <Typography variant="caption" gutterBottom className={head}>
              Description
            </Typography>
            <Typography variant="caption" className={actualBody}>
              {eventDescription}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default EventDescComp;
